import React, { Component } from "react";
import "./style.css";

export default class Loading extends Component {
  render() {
    return (
      <div id="fullHeight">
        <div id="loading" />
      </div>
    );
  }
}
